var render = function render(_c,_vm){return _c(_vm.props.tag || 'div',{tag:"component",class:{
    'rounded d-flex align-center px-2 py-1': true,
    [_vm.props.fontSize || 'font--label-small']: true,
    [_vm.props.color || 'g-text-primary']: true,
    [_vm.props.backgroundColor || 'g-background-primary']: true,
    [_vm.data.staticClass]: !!_vm.data.staticClass,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }